import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { ChartBarHorizontalCustom, Legend } from '../../../../components'
import { LEGEND_COLOR_MAP, GRAPH_COLOR_PALLET2, GRAPH_COLOR_PALLET_V2_TEXT, GRAPH_COLOR_PALLET_V2 } from '../../../../constants'
import {
  BarWrap,
  BarWrapper,
  BarTypography,
  ContentWrap,
  LegendText,
  LegendWrap,
  RowBar,
  SegmentRow,
  SegmentWrap,
  StyledTableHead,
  TableData,
  TableWrapper,
  TdWrapper,
  ToolTipColWrapper,
  TooltipRowName,
  ToolTipContainer,
  ToolTipWrapper,
  ToolTipColName,
  TitleCell,
  SliderWrap,
  TitleWrap,
  BarMainWrap,
  ListWrapper
} from './style'
import { getObjectAsArray, hexToRgba } from '../../../../util'
import { Table, TableBody, TableCell, TableRow, Typography } from '@mui/material'
import Slider from 'react-slick'
import { NextArrow, PrevArrow } from '../reportLandScapeCompetitiveBrandImagery/landScapeHeader'
import { getBackgroundColorOpacityAndTextColor, getTableData } from '../segmentComparison/buyerTable'
import { SegmentRowContent } from '../segmentComparison/style'
import { estimateTextHeight } from '../../../reportsPpt/commonFunctions'

const ProgressionBuyerTable = ({
  view,
  data,
  isExtraColor = true,
  colorPallet = [],
  showLegendToolTip = false,
  allValuesShow,
  progressionRangeObject,
  insightsElementType
}) => {

  const rowSlidersRef = useRef([]);
  const legendSliderRef = useRef([]);
  const titleRefs = useRef([]);
  const [barHeights, setBarHeights] = useState([]);
  const [dataLength, setDataLength] = useState(0);

  useEffect(() => {
    let heights = titleRefs.current.map((el, i) => {
      if (!el) return;
      const maxH = el.offsetHeight || 16;

      el.style.height = maxH + "px";
      return maxH;
    });

    setBarHeights(heights)
  }, [data]);

  const handleNext = () => {
    rowSlidersRef.current.forEach(row => {
      row.forEach(slider => {
        if (slider && slider.innerSlider.state.currentSlide < slider.innerSlider.state.slideCount - slider.props.slidesToShow) {
          slider.slickNext();
        }
      });
    });
    legendSliderRef.current.forEach(slider => {
      if (slider && slider.innerSlider.state.currentSlide < slider.innerSlider.state.slideCount - slider.props.slidesToShow) {
        slider.slickNext();
      }
    });
  };

  const handlePrev = () => {
    rowSlidersRef.current.forEach(row => {
      row.forEach(slider => {
        if (slider && slider.innerSlider.state.currentSlide > 0) {
          slider.slickPrev();
        }
      });
    });
    legendSliderRef.current.forEach(slider => {
      if (slider && slider.innerSlider.state.currentSlide > 0) {
        slider.slickPrev();
      }
    });
  };

  const defaultCarouselSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 6.2,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    swipeToSlide: false,
    draggable: false,
    touchMove: false,
    initialSlide: 0,
    nextArrow: <NextArrow onExtraClick={handleNext} />,
    prevArrow: <PrevArrow onExtraClick={handlePrev} />,
    speed: 0,
  }

  const defaultLegendsSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 6.2,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    swipeToSlide: false,
    draggable: false,
    touchMove: false,
    initialSlide: 0,
    speed: 0,
    arrows: false
  }

  const colors = useMemo(() => {
    if (colorPallet.length > 0) return [...colorPallet];
    return isExtraColor ? [...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT, ...GRAPH_COLOR_PALLET_V2] : [...LEGEND_COLOR_MAP];
  }, [isExtraColor, colorPallet]);

  const largestPercentage = useMemo(() => {
    const allValues = data.flatMap(item =>
      item.SecondarySegmentSet?.SecondarySegment?.map(e => e.SegmentValue || 0) || []
    );

    return allValues.length ? Math.max(...allValues) : 0;
  }, [data]);

  const tableData = useMemo(() => getTableData(data, false), [data]);

  const splitData = (data) => {
    if (!Array.isArray(data)) return [[], []];

    const visible = data.filter(d => d?.show !== false);

    if (visible.length <= 6) return [visible];

    const left = [];
    const right = [];

    visible.forEach((item, i) => {
      if (i % 2 === 0) {
        left.push(item);
      } else {
        right.push(item);
      }
    });

    if (right.length !== left.length) {
      right.push({
        PrimarySegmentName: '',
        show: true,
        SecondarySegmentSet: { SecondarySegment: [] }
      });
    }

    return [left, right];
  };

  useEffect(() => {
    const visible = getObjectAsArray(data[0]?.SecondarySegmentSet?.SecondarySegment).filter(d => d?.show !== false);
    setDataLength(visible?.length || 0);
  }, [data]);

  const visibleColumnIndexes = tableData[0]
    .map((col, i) => (col.show ? i : null))
    .filter(i => i !== null);

  return (
    <>
      {view === 'graph' && (
        <>
          {!!data?.length && (
            <ContentWrap className={`${dataLength > 12 ? 'slider-init' : ''}`}>
              {dataLength > 12 ? (
                <>
                  {allValuesShow && (() => {
                    let rows = [];
                    for (let i = 0; i < 2; i++) {
                      rows.push(
                        <>
                          <SliderWrap>
                            <TitleWrap></TitleWrap>
                            <BarWrap className={`legends ${dataLength > 12 ? 'slider-wrapper' : ''}`}>
                              <Slider ref={el => (legendSliderRef.current[i] = el)}  {...defaultLegendsSettings}>
                                {splitData(getObjectAsArray(data[0]?.SecondarySegmentSet?.SecondarySegment)).map((item, index) => {
                                  if (index === i) {
                                    return item.map(({ SegmentName, SegmentValue, show }, i) => {
                                      if (!show) return;

                                      return (
                                        <LegendText key={index + SegmentName}>{SegmentName}</LegendText>
                                      )
                                    })
                                  } else {
                                    return;
                                  }
                                })}
                              </Slider>
                            </BarWrap>
                          </SliderWrap>


                          <SegmentWrap>
                            <TitleWrap>
                              {data.map((item, index) => {
                                if (!item.show) return;
                                return <TitleCell ref={(el) => (titleRefs.current[index] = el)} key={index + item.PrimarySegmentName}>{item.PrimarySegmentName}</TitleCell>
                              }
                              )}
                            </TitleWrap>

                            <ListWrapper className='slider-wrap'>
                          
                                {data.map((dataItems, dataIndex) => {
                                  if (!dataItems.show) return;
                                  return (
                                    <SegmentRow
                                      className={`list segmentOfSegmentOverviewRow ${!allValuesShow ? 'noVal' : ''}`}
                                      key={dataIndex + dataItems?.PrimarySegmentName}
                                    >

                                      <Slider
                                        ref={el => {
                                          if (!rowSlidersRef.current[i]) {
                                            rowSlidersRef.current[i] = [];
                                          }
                                          rowSlidersRef.current[i][dataIndex] = el;
                                        }}
                                        {...(dataIndex === data.length - 1 && i === 0 ? defaultCarouselSettings : defaultLegendsSettings)}>

                                      {splitData(dataItems?.SecondarySegmentSet?.SecondarySegment).map((item, index) => {
                                        if (index === i) {
                                          return item.map(({ SegmentName, SegmentValue, show, segmentIndex, color, clr }, i) => {
                                            if (!show) return;
                                            const isUndefined = SegmentValue === undefined || SegmentValue === null;
  
                                            return (
                                              <BarMainWrap className='bar-slider' barHeight={barHeights[i]} key={`${SegmentValue}${i}`}
                                                data-age={dataIndex === 0 ? SegmentName : ''}
                                                visible={isUndefined ? 'hidden' : 'visible'}
                                              >
                                                <BarWrapper
                                                  data-primary={item.PrimarySegmentName}
                                                  // bgColor={colors[segmentIndex]}
                                                  bgColor={color}
                                                  barWidth={(SegmentValue / largestPercentage) * 100}>
                                                  <div className='bar-filled'></div>
                                                </BarWrapper>
                                                <BarTypography width='12%' lineHeight='16px' fontWeight={500} fontSize='13px'>{SegmentValue}%</BarTypography>
                                              </BarMainWrap>
                                            )
                                          })

                                        } else {
                                          return;
                                        }
                                      })}
                                      </Slider>
                                    </SegmentRow>
                                  )
                                })}
                            </ListWrapper>
                          </SegmentWrap>
                        </>
                      )
                    }

                    return rows;

                  })()}
                </>
              ) : (
                <>
                  {allValuesShow && (() => {
                    let loopCount = dataLength > 6 ? 2 : 1;
                    let rows = [];

                    for (let i = 0; i < loopCount; i++) {
                      rows.push(
                        <>
                          <BarWrap className='legends'>
                            {splitData(data[0]?.SecondarySegmentSet?.SecondarySegment).map((item, index) => {
                              if (index === i) {
                                return item.map(({ SegmentName, SegmentValue, show }, i) => {
                                  if (!show) return;

                                  return (
                                    <LegendText key={index + SegmentName}>{SegmentName}</LegendText>
                                  )
                                })
                              } else {
                                return;
                              }
                            })}
                          </BarWrap>

                          {data.map((item, dataIndex) => {
                            if (!item.show) return;
                            const { height } = estimateTextHeight(item.PrimarySegmentName, 132, 14 , 16);

                            return (
                              <SegmentRow
                                className={`list segmentOfSegmentOverviewRow ${!allValuesShow ? 'noVal' : ''}`}
                                key={dataIndex + item?.PrimarySegmentName}
                                data-age={item.PrimarySegmentName}
                              >
                                <SegmentRowContent>
                                  <BarWrap className={item?.type?.toLowerCase()}>
                                    {splitData(item?.SecondarySegmentSet?.SecondarySegment).map((item, index) => {
                                      if (index === i) {
                                        return item.map((propsData, i) => {
                                          const { SegmentName, SegmentValue, show, segmentIndex, color, clr } = propsData
                                          if (!show) return;
                                          const isUndefined = SegmentValue === undefined || SegmentValue === null;
 
                                          return (
                                            <BarMainWrap barHeight={barHeights[i]} key={`${SegmentValue}${i}`}
                                              data-age={dataIndex === 0 ? SegmentName : ''}
                                              visible={isUndefined ? 'hidden' : 'visible'}
                                            >
                                              <BarWrapper
                                                data-primary={item.PrimarySegmentName}
                                                // bgColor={colors[segmentIndex]}
                                                // bgColor={color}
                                                bgColor={clr}
                                                barWidth={(SegmentValue / largestPercentage) * 100}>

                                                <div className='bar-filled'></div>
                                              </BarWrapper>
                                              <BarTypography lineHeight='16px' fontWeight={500} fontSize='13px'>{SegmentValue}%</BarTypography>
                                            </BarMainWrap>
                                          )
                                        })

                                      } else {
                                        return;
                                      }
                                    })}

                                  </BarWrap>
                                </SegmentRowContent>
                              </SegmentRow>
                            )
                          })}
                        </>
                      )
                    }

                    return rows;
                  }
                  )()}
                </>
              )}


            </ContentWrap>)}
        </>
      )}

      {view === 'table' && (
        <TableWrapper>
          {!!data.length && allValuesShow ? (
            <>
              <StyledTableHead>
                <TableRow>
                  {visibleColumnIndexes.map((colIndex) => {
                    const td = tableData[0][colIndex];
                    return <TableCell key={'th' + colIndex}>{td.value}</TableCell>;
                  })}
                </TableRow>
              </StyledTableHead>

              <TableBody>
                {tableData.slice(1).map((row, rowIndex) => (
                  <TableRow key={'row' + rowIndex}>
                    {visibleColumnIndexes.map((colIndex) => {
                      const maxValue = Math.max(...tableData.slice(1).flatMap(r => r.slice(1).map(c => Number(c.value) || 0)))
                      const cell = row[colIndex];
                      return (
                        <TableData key={'cell' + rowIndex + '-' + colIndex}>
                          <TdWrapper index={colIndex} textColor={colIndex !== 0 ? colors[rowIndex] : ''}>
                            <>
                              {colIndex !== 0 ? (
                                <BarWrapper className="table-bar" bgColor={cell.clr || colors[rowIndex]} width='100%' barWidth={(cell.value / maxValue) * 100}>
                                {/* <BarWrapper className="table-bar" bgColor={colors[rowIndex]} width='100%' barWidth={(cell.value / maxValue) * 100}> */}
                                  {/* // <BarWrapper className="table-bar" bgColor={colors[rowIndex]} width="62px" barWidth={(cell.value / 100) * 62}> */}
                                  <div className="bar-filled"></div>
                                </BarWrapper>
                              ) : null}

                              {cell.value}
                              {colIndex !== 0 ? '%' : ''}
                            </>
                          </TdWrapper>
                        </TableData>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>

            </>
          ) : (
            <TableRow>
              <TableCell>
                <b>No Data</b>
              </TableCell>
            </TableRow>
          )}
        </TableWrapper>
      )}
    </>
  )
}

export default ProgressionBuyerTable

